import { createContext, useContext } from 'react';

export const TenantContext = createContext<string>('');

/** Provides the current tenant ID. */
export function useTenant(): string {
  return useContext(TenantContext);
}
